// bootstrap and jQuery
import "jquery";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min";
import "./assets/js/iconfont";
import "babel-polyfill";

// import vue
import Vue from "vue";
import App from "./App";
import VueRouter from "vue-router";
import VueResource from "vue-resource";
import VeeValidate from "vee-validate";
import myMessages from "assets/js/myValidationRules";
import Laypage from "vue-laypage";
import clipboard from "vue-clipboard2";
import VueI18n from "vue-i18n";
import routes from "./config/routes";
import activity from "./config/activity";
import VueAnalytics from "vue-analytics";
import store from "./store";
import Toast from "components/toast/toast.js";
import { getApiHost } from "./lib/getApiHost";

Vue.use(VueRouter);
Vue.use(VueResource);
Vue.use(clipboard);
Vue.use(VueI18n);
Vue.use(Toast);

Vue.use(VeeValidate, {
  locale: store.state.currentLang,
  dictionary: {
    locales: myMessages,
  },
});
Vue.component("Laypage", Laypage);
Vue.prototype.$activity = true;
const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    return savedPosition;
  } else {
    const position = {};
    if (to.hash) {
      position.selector = to.hash;
    }
    if (to.matched.some((m) => m.meta.scrollToTop)) {
      position.x = 0;
      position.y = 0;
    }
    return position;
  }
};

const router = new VueRouter({
  mode: "history",
  base: __dirname,
  scrollBehavior,
  routes: routes,
});

Vue.use(VueAnalytics, {
  id: process.env.UA_TRACKING_ID,
  router: router,
});

Vue.http.options.emulateJSON = true;
Vue.http.options.root = getApiHost();

Vue.http.interceptors.push((request, next) => {
  let needAuthorization = store.state.needAuthorization;
  if (window.localStorage.getItem("token") !== null && !!needAuthorization) {
    request.headers.set(
      "Authorization",
      "Bearer " + window.localStorage.getItem("token")
    );
  }
  if (window.localStorage.getItem("clientToken") !== null) {
    request.headers.set(
      "Authorization",
      window.localStorage.getItem("clientToken")
    );
  }
  if (window.localStorage.getItem("deviceId") !== null) {
    request.headers.set(
      "PV-Device-ID",
      window.localStorage.getItem("deviceId")
    );
  }
  if (store.state.currentLang) {
    request.headers.set("PV-Language", store.state.currentLang);
  }
  request.headers.set("Cache-Control", "no-cache");
  next((response) => {
    store.commit("setNeedAuthorization", true);
    if (response.status === 401) {
      store.dispatch("clearUserInfo");
      if (window.localStorage.getItem("clientToken")) {
        window.localStorage.removeItem("clientToken");
        window.localStorage.removeItem("deviceId");
      }
      window.webkit &&
        window.webkit.messageHandlers.signOutAction.postMessage({
          name: "",
        });
      vm.$router.replace("/login");
    }
  });
});

// router-link jump back to the top of the page
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});

/* eslint-disable no-new */

var vm = new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js